// extracted by mini-css-extract-plugin
module.exports = {"Panel":"Panel_Panel__1HC2E","Step":"Panel_Step__3i3_d"};